import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetSupportCategoryRequest } from '@cash-web/shared-util-protos/squareup/cash/supportal/service.pb'
import { GetSupportCategoryResponse } from '@cash-web/shared-util-protos/squareup/cash/supportal/service.pb'

export const getSupportCategory = (request: GetSupportCategoryRequest, options?: CashRequestOptions) =>
  post<GetSupportCategoryRequest, GetSupportCategoryResponse>('/2.0/cash/get-support-category', request, {
    ...options,
    rejectOnError: true,
  })
